import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthResetFormRoutingModule } from './auth-reset-form-routing.module';
import { AuthResetFormComponent } from './auth-reset-form/auth-reset-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUtilityModule } from 'src/app/shared-utility/shared-utility.module';
import { AuthResetConfirmationComponent } from './auth-reset-confirmation/auth-reset-confirmation.component';

@NgModule({
  declarations: [AuthResetFormComponent, AuthResetConfirmationComponent],
  imports: [
    CommonModule,
    AuthResetFormRoutingModule,
    ReactiveFormsModule,
    SharedUtilityModule,
    FormsModule
  ]
})
export class AuthResetFormModule { }
